import ApiClient from "src/config/ApiClient";

export const createMenuOnServer = async (menuData) => {
  return ApiClient.post("/menu", menuData);
};

export const updateMenuOnServer = async (customerId, menuId, data) => {
  return ApiClient.patch(`/menu/patch/${customerId}/${menuId}`, data);
};

export const updateItemQuantity = async (
  customerId,
  menuId,
  itemId,
  operation
) => {
  return ApiClient.patch(`/menu/patch/${customerId}/${menuId}/${itemId}`, {
    operation,
  });
};
